import { enumBookScope } from "../constants";

export function bookRenderInfo() {
  this.fPubPanel = null;
  this.fPageRetryQ = null;
  this.fPageWidth = null;
  this.fPageHeight = null;
  this.fPageList = null;
  this.fFileName = null;
  this.fTransaction = null;
  this.fOverwrite = null;
  this.fCurrentSC = null;
  this.fNumPages = null;

  this.fWorkingLayer = null;
  this.fWorkingPage = null;
  this.fWorkingStep = null;

  this.fPubScope = enumBookScope.entire;
  this.fAltCanvas = null;
  this.fOutputDocRef = null;

  this.fCurDocIdx = null;
  this.fMultiDocCompletedPages = null;
}
